import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Col } from 'react-styled-flexboxgrid';

import { SafeFormattedMessage } from '@savgroup-front-common/core/formatters';
import { formatReverseMoneyToString } from '@savgroup-front-common/core/formatters/intl';
import { RawQuotationServiceEnriched } from '@savgroup-front-common/types';

import messages from '../messages';
import {
  $InlinePriceCol,
  $QuoteItemSummaryRow,
} from '../QuotationValidationSummary.styles';

interface ServiceSummaryLineProps {
  services?: RawQuotationServiceEnriched[];
}

const ServiceSummaryLine: FunctionComponent<
  React.PropsWithChildren<ServiceSummaryLineProps>
> = ({ services }) => {
  if (!services) {
    return null;
  }

  return (
    <>
      {services.map(({ id, description, quantity, amountIncludedTax }) => {
        return (
          <$QuoteItemSummaryRow key={id} between="xs">
            <Col xs={7} sm={8}>
              <SafeFormattedMessage {...messages.service} /> -{' '}
              {quantity > 1 ? `${quantity}x` : null}
              {description}
            </Col>
            <$InlinePriceCol xs={5} sm={4}>
              {formatReverseMoneyToString(amountIncludedTax)}
              <FormattedMessage {...messages.vatIncluded} />
            </$InlinePriceCol>
          </$QuoteItemSummaryRow>
        );
      })}
    </>
  );
};

ServiceSummaryLine.displayName = 'ServiceSummaryLine';

export default ServiceSummaryLine;
